/*
 * Copyright (c) 2023. Haodong JU
 */

import GlobalSettings from '@/model/global/GlobalSettings'
import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import hillo from 'hillo'
import Payment from '@/model/dataLayer/api/common/Payment'

const entity = {
  id: {
    type: IKDataEntity.Types.Integer,
    displayName: 'id',
    tableConfig: {
      align: 'start'
    },
    form: false
  },
  paymentMethodId: {
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        selectItems: Payment.getList,
        itemText: '_langsname'
      }
    },
    displayName: 'PaymentType'
  },
  createdAt: { form: false },
  memberCardId: {
    form: false
  },
  amount: {
    form: false
  }
}
const config = {
  load: async function (filter) {
    return (await hillo.get('BackendData.php', Object.assign({
      op: 'billDetail',
      lang: GlobalSettings.getLang()
    }, ...filter)))
      .billPaymentInfo
  }
}

export default IKDataEntity.ModelFactory(entity, config)
